import React from "react";
import { Link } from "react-router-dom";


const Header = () => {
  const pathname = window.location.pathname;

  const getAttributr = (name) => {
    if (pathname === name) {
      return "common-btn btn-transparent btn-blue";
    } else {
      return "common-btn btn-transparent";
    }
  };

  return (
    <div>
      <header>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="flex-menu d-flex align-items-center justify-content-end top-block">
                {/* <div className="languages">
                                    <label>Languages :</label>
                                    <div className="language-dropdown">
                                        <Link to="/" className="language-toggler d-block d-md-none">English</Link>
                                        <ul className="language-list d-md-flex">
                                            <li><Link to="/">English</Link></li>
                                            <li><Link to="/">Spanish</Link></li>
                                            <li><Link to="/">Arabic</Link></li>
                                            <li><Link to="/">Hindi</Link></li>
                                        </ul>
                                    </div>
                                </div> */}
              </div>
            </div>
            <div className="col-12">
              <div className="logo-section d-flex align-items-center justify-content-between">
                <div className="head-logo">
                  <Link to="/home">
                    <img src="/assets/images/logo.svg" alt="neet" />
                  </Link>
                </div>
                <ul className="login-nav d-flex align-items-center">
                  <li>
                    <Link to="/home" className={getAttributr("/home")}>
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/signup" className={getAttributr("/signup")}>
                      Sign up
                    </Link>
                  </li>
                  <li>
                    <Link to="/signin" className={getAttributr("/signin")}>
                      Log in 
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};
export default Header;
